<template lang="pug">
#mapa-leaflet(
    :style='{ height: height }',
    style='position: relative',
    :class='{ popupDeslocado: deslocarPopup }'
)
    div(
        :id='idMapa',
        :style='{ height: height }',
        v-observe-visibility='visibilityChanged'
    )
    button.btn(
        @click='finalizarEdicaoDeDesenho',
        v-if='alterandoGeometria',
        style='color: var(--primary); position: absolute; left: 45%; top: 90%; z-index: 1000'
    )
        i.mdi.mdi-check
        | {{ $t('mensagens.menuMapa.finalizarEdicaoDesenho') }}

    DrawerInspecionarCamadas(
        :show='mostrarDrawerInspecionar',
        :geometria='geometriaAcao',
        :camadas='camadasInspecao',
        :menuMaior='menuMaior',
        @fechar='fecharDrawerInspecionar'
    )

    .drawer-historico-agricola(v-if='mostrarDrawerHistoricoAgricola && mapa')
        DrawerHistoricoAgricola(
            :show='mostrarDrawerHistoricoAgricola',
            :geometria='geometriaAcao',
            :featureGroup='featureGroup',
            :mapa='mapa',
            @drawerHistoricoAgricolaFechar='drawerHistoricoAgricolaFechar'
        )

    .selecionar-camadas
        ModalSelecionarCamadas(
            :show='mostrarModalSelecionarCamadas',
            :camadasInspecao='camadasInspecao',
            @fechar='mostrarModalSelecionarCamadas = false',
            @inspecionar='inspecionar'
        )

    .enviar-diagnostico
        ModalEnviarGeometriaDiagnostico(
            :show='mostrarModalEnviarGeometriaDiagnostico',
            :geometria='geometriaAcao',
            @fechar='mostrarModalEnviarGeometriaDiagnostico = false'
        )
    DrawerMenuFerramentas(
        :show='ativarMenuFerramentas',
        :menuMaior='menuMaior',
        :mapConfigControls='mapConfig.controls',
        :limparMenuFerramentasAtivo='limparMenuFerramentasAtivo',
        :mapa='mapa || {}',
        @fixaZoom='fixaZoom',
        @adicionarAnotacao='adicionarAnotacao',
        :dadosDaAnotacaoEdicao='dadosDaAnotacaoEdicao',
        @dadosFormCoodernadas='dadosFormCoodernadas',
        @createMarkerOnClick='createMarkerOnClick',
        @closeDrawerMenuFerramentas='toggleMenuFerramentas',
        @resetarLimparMenuFerramentasAtivo='limparMenuFerramentasAtivo = false',
        @showPopupAcoes='showPopupAcoes'
    )
    DrawerMenuArea(
        :show='ativarMenuArea',
        :menuMaior='menuMaior',
        :mapConfigControls='mapConfig.controls',
        :limparMenuAreaAtivo='limparMenuAreaAtivo',
        @rulerActivate='rulerActivate',
        @drawControlCalc='drawControlCalc',
        @closeDrawerMenuArea='toggleMenuArea',
        @resetarLimparMenuAreaAtivo='limparMenuAreaAtivo = false'
    )
    DrawerMenuCamadas(
        :show='ativarMenuCamadas',
        :menuMaior='menuMaior',
        :mapa='mapa || {}',
        :showStatesLayers='showStatesLayers',
        :limparMenuCamadasAtivo='limparMenuCamadasAtivo',
        @closeDrawerMenuCamadas='toggleMenuCamadas',
        @resetarLimparMenuCamadasAtivo='limparMenuCamadasAtivo = false',
        @atualizarListaCamadasModalInspecionar='atualizarListaCamadasModalInspecionar'
    )
    FerramentasSentinelHub(
        :show='ativarFerramentasSentinelHub',
        :menuMaior='menuMaior',
        :mapConfigControls='mapConfig.controls',
        :mapa='mapa',
        :selectorIdMapa='selectorIdMapa',
        @closeFerramentasSentinelHub='toggleFerramentasSentinelHub',
        @resetarLimparMenuFerramentasAtivo='limparMenuFerramentasAtivo = false'
    )
</template>

<script>
import L from 'leaflet';
import 'leaflet-easybutton';
import 'leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-easybutton/src/easy-button.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/leaflet.markercluster-src';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.js';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.css';
import 'leaflet-contextmenu';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';
import 'leaflet-measure-path';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.js';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.css';

import LayerStyles from '@/utils/layerStyles';

import Buffer from '@/components/mapa/buffer/Buffer.vue';
import BuscaCar from '@/components/mapa/buscaCar/BuscaCar.vue';
import ModalCoordenadas from './mapa/popup/ModalCoordenadas.vue';
import CamadasBase from '@/components/mapa/camadasBase/CamadasBase.vue';
import Popup from '@/components/mapa/camadas/PopupCarSelecionadoNoMapaTerritorio.vue';
import ControleLeafletComComponenteVue from '@/utils/mapa/ControleLeafletComComponenteVue';
import Supercluster from 'supercluster';
import EventBus from '@/utils/eventBus';
import geometryUtils from '@/utils/mapa/geometry.js';

import UtilsService from '@/services/UtilsService';

import mapaEstilos, { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import {
    DEFAULT_CONFIG,
    BASE_LAYERS_CONFIG,
    TILE_LAYER_CONFIG,
    DEFAULT_CONFIG_PARAGUAY
} from '@/utils/mapa/mapa.config';

import i18n from '@/main';
import { toDecimal } from 'geolib';
import IMask from 'imask';

import OptionsRuler from '@/constants/OptionsRuler';
import DrawCalc from '@/constants/DrawCalc';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import Utm from 'geodesy/utm';

import DrawerInspecionarCamadas from '@/components/DrawerInspecionarCamadas';
import DrawerHistoricoAgricola from '@/components/DrawerHistoricoAgricola';
import ModalSelecionarCamadas from '@/components/ModalSelecionarCamadas';
import ModalEnviarGeometriaDiagnostico from '@/components/ModalEnviarGeometriaDiagnostico';
import DrawerMenuFerramentas from '@/components/DrawerMenuFerramentas';
import DrawerMenuArea from '@/components/DrawerMenuArea';
import DrawerMenuCamadas from '@/components/DrawerMenuCamadas';
import FerramentasSentinelHub from '@/components/sentinelHub/FerramentasSentinelHub';

import { mapActions, mapState } from 'vuex';
import { sortBy } from 'lodash';

import ModalAnotacao from '@/components/mapa/popup/ModalAnotacao';

import { uuid } from 'vue-uuid';

export default {
    name: 'Mapa',

    components: {
        DrawerInspecionarCamadas,
        ModalSelecionarCamadas,
        DrawerHistoricoAgricola,
        ModalEnviarGeometriaDiagnostico,
        ModalCoordenadas,
        ModalAnotacao,
        DrawerMenuFerramentas,
        DrawerMenuArea,
        DrawerMenuCamadas,
        FerramentasSentinelHub
    },

    props: {
        height: {
            required: false,
            type: String,
            default: '100%'
        },

        mapConfig: {
            required: false,
            type: Object
        },

        mapLayersConfigs: {
            required: false,
            type: Array
        },

        locked: {
            required: false,
            type: Boolean,
            default: false
        },

        idMapa: {
            required: true,
            type: String
        },

        deslocarPopup: {
            type: Boolean,
            required: false,
            default: false
        },

        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        },

        camadaCentralizadaNome: {
            type: String,
            required: false
        },

        atualizarMapa: {
            type: Boolean,
            required: false,
            default: true
        },

        cluster: {
            type: Boolean,
            required: false,
            default: true
        },

        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },

        doubleMapOnPage: {
            type: Boolean,
            required: false,
            default: false
        },

        cadastroTerritorio: {
            type: Boolean,
            required: false,
            default: false
        },

        ligarDesenho: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            mapa: null,
            config: {},
            featureGroup: null,
            clusterLayer: null,
            mapLayers: null,
            imageLayer: null,
            alterandoGeometria: false,
            popupDeslocado: 'popup-deslocado',
            drawMarker: null,
            markerTipo: 'decimal',
            mostrarDrawerInspecionar: false,
            mostrarDrawerHistoricoAgricola: false,
            coordenadas: {},
            mostrarModalSelecionarCamadas: false,
            camadasInspecao: [],
            geometriaAcao: {},
            renderComponente: false,
            camadas: [],
            mostrarModalEnviarGeometriaDiagnostico: false,
            drawMarkerAnotacao: null,
            desabilitaZoom: false,
            dadosDaAnotacao: null,
            dadosDaAnotacaoEdicao: null,
            comentarioEmEdicao: false,
            menuLateralIsOpen: false,
            fullscreenAtivado: false,
            selectorIdMapa: '',
            buscarCarIsOpen: false,
            uploadFileIsOpen: false,
            imagensSentinelIsOpen: false,
            layerSelecionadaZoom: null,
            fecharCaminhoMedir: true,
            ativarMenuFerramentas: false,
            ativarMenuArea: false,
            ativarFerramentasSentinelHub: false,
            limparMenuFerramentasAtivo: false,
            limparMenuAreaAtivo: false,
            ativarMenuCamadas: false,
            limparMenuCamadasAtivo: false,
            drawPolygon: null,
            geometrias: [],
            ambientes: AmbientesEmpresas,
            markers: {}
        };
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    mounted() {
        this.initializeComponent();
    },

    watch: {
        '$i18n.locale': function (newLocale) {
            this.reloadComponent();
        },

        ligarDesenho: {
            handler(val) {
                if (!val) {
                    this.drawPolygon.disable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                } else {
                    this.draw();
                }
            }
        },

        mapLayersConfigs: {
            handler(val) {
                this.clearLayers();
                if (this.mapLayersConfigs.length === 0) {
                    this.limparLayerSelecionadaZoom();
                    this.limparAreaAgricultavelLayerSelecionadaZoom();
                } else {
                    if (
                        (val && val[0] && val[0].featureGroup) ||
                        !this.cluster
                    ) {
                        this.addMapLayerWithoutCluster();
                    } else {
                        this.addMapLayers();
                    }
                }
                if (val.length === 1 || this.atualizarMapa) {
                    this.$nextTick(() => {
                        this.refreshMap();
                    });
                }
            },
            immediate: true
        },

        mapConfig: function () {
            this.addMapControls();
        },

        camadaCentralizadaNome: function () {
            if (this.atualizarMapa) {
                this.centralize();
            }
        },

        mostrarDrawerInspecionar(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuCamadas(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuFerramentas(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                if (!this.desabilitaZoom) {
                    this.changeMapInteractiveDrawers(false);
                }
            }
        },

        ativarMenuArea(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarFerramentasSentinelHub(val) {
            if (val) {
                this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'ATIVAR_MENU_SENTINEL_HUB', pageTitle: 'ATIVAR_MENU_SENTINEL_HUB', routeName: this.$route?.name, routePath: this.$route?.path });
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        }
    },

    methods: {
        reloadComponent() {
            if (this.mapa) {
                this.mapa.remove();
                this.mapa = null;
            }
            this.initializeComponent();
        },

        initializeComponent() {
            this.selectorIdMapa = `#${this.idMapa}`;
            this.config = Object.assign(DEFAULT_CONFIG, this.mapConfig);

            if (!this.mapa) {
                this.createMap();
            }

            this.clearEvents();

            this.addEscListener();

            this.handleFullscreenClick();

            this.handleClickOutsideMenus();
        },

        ...mapActions(['setGeometriaDesenhadaAcao', 'setAcaoEscolhida']),

        handleFullscreenClick() {
            if (this.mapConfig.controls.fullscreen) {
                const vm = this;
                var fullScreenButton = document.querySelector(
                    vm.selectorIdMapa + ' .leaflet-control-fullscreen-button'
                );

                fullScreenButton.addEventListener('click', function () {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;

                    setTimeout(() => {
                        if (vm.ativarMenuFerramentas && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-ferramentas'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-ferramentas')
                                );
                            }
                            vm.handleModalAnotacaoInputsOnFullscreen();
                        }

                        if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-area'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-area')
                                );
                            }
                        }

                        if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#drawer-menu-camadas'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#drawer-menu-camadas')
                                );
                            }
                        }

                        if (vm.ativarFerramentasSentinelHub && vm.fullscreenAtivado) {
                            if (vm.doubleMapOnPage) {
                                $(vm.selectorIdMapa).prepend(
                                    document.querySelectorAll(
                                        '#ferramentas-sentinel'
                                    )[1]
                                );
                            } else {
                                $(vm.selectorIdMapa).prepend(
                                    $('#ferramentas-sentinel')
                                );
                            }
                            vm.handleSentinelInputsOnFullscreen();
                        }
                    }, 150);
                });
            }
        },

        handleClickOutsideMenus() {
            const vm = this;
            setTimeout(() => {
                window.onclick = function (event) {
                    let elDrawerCamadas; let elDrawerFerramentas; let elDrawerArea; let elDrawerSentinelHub; let elDrawerInspecionarCamadas;

                    if (vm.doubleMapOnPage) {
                        elDrawerCamadas = document.querySelectorAll(
                            '#drawer-menu-camadas .el-drawer'
                        )[1];
                        elDrawerFerramentas = document.querySelectorAll(
                            '#drawer-menu-ferramentas .el-drawer'
                        )[1];
                        elDrawerArea = document.querySelectorAll(
                            '#drawer-menu-area .el-drawer'
                        )[1];
                        elDrawerSentinelHub = document.querySelectorAll(
                            '#ferramentas-sentinel .el-drawer'
                        )[1];
                        elDrawerInspecionarCamadas = document.querySelectorAll(
                            '#drawer-inspecionar-camadas .el-drawer'
                        )[1];
                    } else {
                        elDrawerCamadas = document.querySelectorAll(
                            '#drawer-menu-camadas .el-drawer'
                        )[0];
                        elDrawerFerramentas = document.querySelectorAll(
                            '#drawer-menu-ferramentas .el-drawer'
                        )[0];
                        elDrawerArea = document.querySelectorAll(
                            '#drawer-menu-area .el-drawer'
                        )[0];
                        elDrawerSentinelHub = document.querySelectorAll(
                            '#ferramentas-sentinel .el-drawer'
                        )[0];
                        elDrawerInspecionarCamadas = document.querySelectorAll(
                            '#drawer-inspecionar-camadas .el-drawer'
                        )[0];
                    }

                    if (
                        event.target.contains(elDrawerCamadas) &&
                        event.target !== elDrawerCamadas
                    ) {
                        if (vm.ativarMenuCamadas) {
                            vm.toggleMenuCamadas();
                        }
                    }

                    if (
                        event.target.contains(elDrawerFerramentas) &&
                        event.target !== elDrawerFerramentas
                    ) {
                        if (vm.ativarMenuFerramentas) {
                            vm.toggleMenuFerramentas();
                        }
                    }

                    if (
                        event.target.contains(elDrawerArea) &&
                        event.target !== elDrawerArea
                    ) {
                        if (vm.ativarMenuArea) {
                            vm.toggleMenuArea();
                        }
                    }

                    if (
                        event.target.contains(elDrawerInspecionarCamadas) &&
                        event.target !== elDrawerInspecionarCamadas
                    ) {
                        if (vm.mostrarDrawerInspecionar) {
                            vm.fecharDrawerInspecionar();
                        }
                    }

                    if (
                        event.target.contains(elDrawerSentinelHub) &&
                        event.target !== elDrawerSentinelHub
                    ) {
                        if (vm.ativarFerramentasSentinelHub) {
                            vm.toggleFerramentasSentinelHub();
                            setTimeout(() => {
                                $(vm.selectorIdMapa + ' .leaflet-top').removeClass(
                                    'fullscreen-ativado'
                                );
                            }, 10);
                        }
                    }
                };
            }, 200);
        },

        clearEvents() {
            EventBus.$off('retorna-geometria-car');
            EventBus.$on('retorna-geometria-car', this.showPopupAcoes);
            this.$root.$on('remove-map-layer', this.removerDesenho);
        },

        finalizarEdicaoDeDesenho() {
            var editedLayers = L.markerClusterGroup();
            this.featureGroup.eachLayer(layer => {
                if (layer.edited) {
                    editedLayers.addLayer(layer);
                    layer.edited = false;
                    layer.editing.disable();
                }
            });
            this.alterandoGeometria = false;
            this.$emit('draw-edited', editedLayers);
        },

        alterarGeometria(event) {
            event.target.editing.enable();
            this.alterandoGeometria = true;
        },

        visibilityChanged() {
            this.refreshMap();
        },

        createMap() {
            L.drawLocal = {
                draw: {
                    handlers: {
                        polygon: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaDesenharPoligono'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaContinuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.cliquePrimeiroPontoParaTerminar'
                                )
                            }
                        },
                        polyline: {
                            error: i18n?.t(
                                'mensagens.menuMapa.erro.arestasNaoPodemCruzar'
                            ),
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.desenharLinha'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        },
                        marker: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.inserirMarcador'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        }
                    }
                }
            };

            L.Map.include({
                _initControlPos: function () {
                    const corners = (this._controlCorners = {});
                    const container = (this._controlContainer =
                        L.DomUtil.create(
                            'div',
                            'leaflet-control-container',
                            this._container
                        ));

                    function createCorner(vSide, hSide) {
                        const className = `leaflet-${vSide} leaflet-${hSide}`;

                        corners[vSide + hSide] = L.DomUtil.create(
                            'div',
                            className,
                            container
                        );
                    }

                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);

                    createCorner('top', 'left');
                    createCorner('top', 'right');
                    createCorner('bottom', 'left');
                    createCorner('bottom', 'right');
                    createCorner('top', 'center');
                    createCorner('middle', 'center');
                    createCorner('middle', 'left');
                    createCorner('middle', 'right');
                    createCorner('bottom', 'center');
                }
            });

            this.mapa = L.map(this.idMapa, {
                contextmenu: this.mapConfig.inspecionar,
                contextmenuItems: [
                    {
                        text: this.$t(`mensagens.comuns.inspecionar`),
                        callback: this.selecionarCamadas
                    }
                ],
                ...this.config,
                maxZoom: 17
            });

            this.featureGroup = L.featureGroup();

            this.featureGroup.addTo(this.mapa);

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attribution: TILE_LAYER_CONFIG.attribution
            }).addTo(this.mapa);

            if (this.permissaoAmbiente(this.ambientes.PARAGUAY) && this.idMapa !== 'mapaSobreposicaoTerritorio') {
                this.mapa.setView([-23.447949, -58.452454], 6);
            }

            if (!this.locked) {
                this.addMapControls();
            }

            if (!_.isEmpty(this.mapLayersConfigs)) {
                this.addMapLayers();
            }

            this.changeMapInteractive();

            const self = this;

            this.mapa.on(L.Draw.Event.CREATED, e => {
                if (self.dadosDaAnotacao === null) {
                    let layer = e.layer;
                    layer.layerType = e.layerType;

                    this.showPopupAcoes(layer);
                }
            });

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll(
                        '#drawer-menu-camadas'
                    )[1]
                );
            } else {
                $(this.selectorIdMapa).prepend(
                    $('#drawer-menu-camadas')
                );
            }

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll(
                        '#drawer-menu-ferramentas'
                    )[1]
                );
            } else {
                $(this.selectorIdMapa).prepend(
                    $('#drawer-menu-ferramentas')
                );
            }

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll(
                        '#drawer-menu-area'
                    )[1]
                );
            } else {
                $(this.selectorIdMapa).prepend(
                    $('#drawer-menu-area')
                );
            }

            if (this.doubleMapOnPage) {
                $(this.selectorIdMapa).prepend(
                    document.querySelectorAll(
                        '#ferramentas-sentinel'
                    )[1]
                );
            } else {
                $(this.selectorIdMapa).prepend(
                    $('#ferramentas-sentinel')
                );
            }
        },

        addMapLayers() {
            const pointFeatures = [];
            const nonPointFeatures = [];

            this.mapLayersConfigs.forEach(layerConfig => {
                let feature;

                if (layerConfig.geoJson.type === 'Feature') {
                    feature = layerConfig.geoJson;
                    feature.properties = {
                        ...feature.properties,
                        style: layerConfig.style,
                        popup: layerConfig.popup,
                        tooltip: layerConfig.tooltip,
                        name: layerConfig.name,
                        acaoClick: layerConfig.acaoClick
                    };
                } else {
                    feature = {
                        type: 'Feature',
                        geometry: layerConfig.geoJson,
                        properties: {
                            style: layerConfig.style,
                            popup: layerConfig.popup,
                            tooltip: layerConfig.tooltip,
                            name: layerConfig.name,
                            acaoClick: layerConfig.acaoClick
                        }
                    };
                }

                if (feature.geometry.type === 'Point') {
                    pointFeatures.push(feature);
                } else {
                    nonPointFeatures.push(feature);
                }
            });

            if (nonPointFeatures.length) {
                const nonPointLayer = L.geoJSON(nonPointFeatures, {
                    style: (feature) => feature.properties.style,
                    onEachFeature: (feature, layer) => {
                        const properties = feature.properties;
                        if (properties.popup) {
                                layer.bindPopup(properties.popup, {
                                autoClose: false,
                                closeOnClick: false
                            });
                        }
                        if (properties.tooltip) {
                            layer.bindTooltip(properties.tooltip);
                        }
                        if (properties.name) {
                            layer.name = properties.name;
                            this.camadas[properties.name] = layer;
                        }
                    }
                });
                this.featureGroup.addLayer(nonPointLayer);
            }

            if (pointFeatures.length) {
                this.createSuperclusterLayer(pointFeatures);
            }
        },

        createSuperclusterLayer(pointFeatures) {
            const index = new Supercluster({
                radius: 40,
                maxZoom: 15,
                initial: function () {},
                map: function (props) {
                return {
                    style: props.style,
                    popup: props.popup,
                    tooltip: props.tooltip,
                    name: props.name
                };
                },
                reduce: function (accumulated, props) {}
            });

            index.load(pointFeatures);

            this.superclusterIndex = index;

            this.clusterLayer = L.featureGroup();

            const createClusterIcon = (cluster) => {
                const count = cluster.properties.point_count_abbreviated || cluster.properties.point_count;
                let size = 'small';

                if (count < 100) {
                    size = 'small';
                } else if (count < 1000) {
                    size = 'medium';
                } else if (count < 10000) {
                    size = 'large';
                } else {
                    size = 'xlarge';
                }

                const iconSize = size === 'small' ? 30 : size === 'medium' ? 35 : size === 'large' ? 40 : 45;

                return L.divIcon({
                    html: `<div><span>${count}</span></div>`,
                    className: `cluster-marker cluster-marker-${size}`,
                    iconSize: L.point(iconSize, iconSize)
                });
            };

            const updateClusters = () => {

                this.clusterLayer.clearLayers();

                const bounds = this.mapa.getBounds();
                const zoom = this.mapa.getZoom();

                const clusters = index.getClusters(
                    [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()],
                    zoom
                );

                clusters.forEach((cluster) => {
                const [longitude, latitude] = cluster.geometry.coordinates;

                if (cluster.properties.cluster) {
                    const clusterMarker = L.marker([latitude, longitude], {
                        icon: createClusterIcon(cluster)
                    });

                    clusterMarker.on('click', () => {
                        const expansionZoom = index.getClusterExpansionZoom(cluster.id);
                        this.mapa.setView([latitude, longitude], expansionZoom);
                    });

                    this.clusterLayer.addLayer(clusterMarker);
                } else {
                    const properties = cluster.properties;
                    const marker = L.marker([latitude, longitude], {
                        icon: L.icon({
                            iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
                            iconSize: [18, 26]
                        })
                    });

                    marker.feature = cluster;
                    
                    this.markers[properties.name] = marker;

                    if (properties.popup) {
                        marker.bindPopup(properties.popup, {
                            autoClose: true,
                            closeOnClick: true
                        });
                    }

                    if (properties.tooltip) {
                        marker.bindTooltip(properties.tooltip);
                    }
                    if (properties.name) {
                        marker.name = properties.name;
                        this.camadas[properties.name] = marker;
                    }

                    if (properties.acaoClick) {
                        marker.on('click', properties.acaoClick);
                    }

                    this.clusterLayer.addLayer(marker);
                }
                });
            };

            updateClusters();

            this.mapa.on('zoomend', updateClusters);

            this.clusterLayer.addTo(this.mapa);
        },

        getClusterRadius(count) {
            return Math.max(10, Math.min(20, count / 10));
        },

        addMapLayerWithoutCluster() {
            const featureGroupGeometry = [];

            this.mapLayersConfigs.forEach(layerConfig => {
                if (!layerConfig.geoJson) {
                    return;
                }

                let geometry = null;

                if (layerConfig.geoJson.type === 'Point') {
                    geometry = this.addPointLayer(layerConfig);
                    featureGroupGeometry.push(geometry);
                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                } else {
                    geometry = L.geoJSON(
                        layerConfig.geoJson,
                        layerConfig.style
                    );

                    if (layerConfig.tooltip) {
                        geometry.bindTooltip(layerConfig.tooltip);
                    }

                    if (layerConfig.popup) {
                        geometry.bindPopup(layerConfig.popup);
                    }
                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                    geometry._layers[geometry._leaflet_id - 1].name =
                        layerConfig.name;
                    geometry._layers[geometry._leaflet_id - 1].group =
                        layerConfig.group;

                    featureGroupGeometry.push(geometry);
                }
            });

            this.featureGroup = L.featureGroup(featureGroupGeometry);

            if (!this.mapa.hasLayer(this.featureGroup)) {
                this.featureGroup.addTo(this.mapa);
            }

            if (this.atualizarMapa) {
                this.refreshMap();
            }
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.paisGrupo === ambiente;
        },

        addEscListener() {
            const vm = this;
            $(document).bind('fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange', function (e) {
                var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement || document.msFullscreenElement;

                if (!fullscreenElement) {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;

                    if (vm.ativarMenuFerramentas && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-ferramentas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-ferramentas')
                            );
                        }
                        vm.handleModalAnotacaoInputsOnFullscreen();
                    }

                    if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-area'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-area')
                            );
                        }
                    }

                    if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-camadas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }
                    }

                    if (vm.ativarFerramentasSentinelHub && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#ferramentas-sentinel'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#ferramentas-sentinel')
                            );
                        }
                        vm.handleSentinelInputsOnFullscreen();
                    }
                }
            });

            document.addEventListener('keyup', (e) => {
                if (e.keyCode === 27) {
                    $(
                        vm.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    $(vm.selectorIdMapa + ' .leaflet-interactive.drawCalc').removeClass('active');
                    $(vm.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                }
            });
        },

        addMapControls() {
            this.zoomControl();
            this.centralizeControl();

            if (this.mapConfig.controls.popupControl) {
                this.popupControl();
            }
            if (this.mapConfig.controls.fullscreen) {
                this.fullscreenControl();
            }
            if (
                this.mapConfig.controls.buscarCarControl === undefined ||
                this.mapConfig.controls.buscarCarControl
            ) {
                this.addBuscaCarControl();
            }
            if (this.mapConfig.controls.camadasControl) {
                this.camadasControl();
            }
            if (this.usuarioLogado.sentinelHubAccess) {
                this.addBotaoSentinelHub(this.cadastroTerritorio);
            }
            if (this.mapConfig.controls.ferramentasControl !== false) {
                this.addBotaoFerramentas();
            }
            this.addBotaoArea();
            this.rulerControl();
            if (
                this.mapConfig.controls.bufferControl === undefined ||
                this.mapConfig.controls.bufferControl
            ) {
                this.addBufferControl();
            }

            L.control
                .coordinates({
                    position: 'bottomcenter',
                    decimals: 10,
                    decimalSeperator: '.',
                    labelTemplateLat: 'Latitude: {y}',
                    labelTemplateLng: 'Longitude: {x}',
                    enableUserInput: false,
                    useDMS: false,
                    useLatLngOrder: false,
                    centerUserCoordinates: true,
                    markerType: L.marker,
                    markerProps: {}
                })
                .addTo(this.mapa);

            this.markerControl();

            if (this.mapConfig.controls.camadasBaseControl) {
                this.camadasBaseControl();
            }

            if (this.mapConfig.controls.drawControl) {
                this.drawControl();
            }
        },

        addMapPopupControls() {
            if (this.mapConfig.controls.popupControl) {
                this.popupControl();
            } else {
                this.refreshMap();
                document.getElementById('popup').style.display = 'none';
            }
        },

        zoomControl(zoom) {
            L.control
                .zoom({
                    position: 'topright',
                    zoomControl: false
                })
                .addTo(this.mapa);
        },

        fixaControl() {
            L.easyButton({
                id: 'botao-fixar-zoom',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: btn => this.fixaZoom(btn),
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.fixarZoom'),
                        icon: 'mdi mdi-pin'
                    }
                ]
            }).addTo(this.mapa);
        },

        centralizeControl() {
            L.easyButton({
                id: 'botao-centralizar-zoom',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.centralize(),
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.centralizar'),
                        icon: 'mdi mdi-crosshairs-gps'
                    }
                ]
            }).addTo(this.mapa);
        },

        rulerControl() {
            L.control.ruler(OptionsRuler.DEFAULT).addTo(this.mapa);
            $(this.selectorIdMapa + ' .leaflet-bar.leaflet-ruler.leaflet-control').addClass('none');
        },

        rulerActivate() {
            setTimeout(() => {
                $(this.selectorIdMapa + ' .leaflet-bar.leaflet-ruler.leaflet-control').click();
            }, 200);
        },

        drawControl() {
            const polyOptions = {
                allowIntersection: false,
                drawError: {
                    color: '#e1e100',
                    message:
                        '<strong>As arestas do polígono não devem se cruzar</strong>'
                },
                shapeOptions: {
                    color: '#bada55',
                    showMeasurements: false
                },
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                }),
                touchIcon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                })
            };

            this.drawPolygon = new L.Draw.Polygon(this.mapa, polyOptions);
            document.addEventListener(
                'keydown',
                function (event) {
                    if (event.key === 'Escape' && this.drawPolygon.enabled()) {
                        this.emitEventsTerritorio();
                        this.drawPolygon.disable();
                        $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                    }
                }.bind(this)
            );
            L.easyButton({
                id: 'botao-desenhar',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.draw(),
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.desenhar'),
                        icon: 'mdi mdi-pencil-outline'
                    }
                ]
            }).addTo(this.mapa);

            $(this.selectorIdMapa + ` .leaflet-interactive[title="${this.$t('mensagens.menuMapa.iconesFerramentas.desenhar')}"]`).addClass('draw');
        },

        drawControlCalc() {
            const polyOptionsCalc = DrawCalc.OPTIONS;

            this.drawPolygonCalc = new L.Draw.Polygon(
                this.mapa,
                polyOptionsCalc
            );

            this.drawCalc();
        },

        addBufferControl() {
            const config = {
                classeControle: 'leaflet-control-buffer',
                position: 'bottomcenter'
            };
            ControleLeafletComComponenteVue(Buffer, this.mapa, {}, config);
        },

        addBuscaCarControl() {
            const config = {
                classeControle: 'leaflet-control-busca-car',
                position: 'topright'
            };
            ControleLeafletComComponenteVue(
                BuscaCar,
                this.mapa,
                { mapa: this.mapa },
                config
            );
        },

        camadasBaseControl() {
            const configCamadas = BASE_LAYERS_CONFIG;

            const config = {
                classeControle: 'leaflet-control-camadas-base',
                position: 'bottomright'
            };
            ControleLeafletComComponenteVue(
                CamadasBase,
                this.mapa,
                { configCamadas },
                config
            );
        },

        camadasControl() {
            L.easyButton({
                id: 'botao-camadas',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-camadas',
                        onClick: this.toggleMenuCamadas,
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.camadas'),
                        icon: 'mdi mdi-layers-outline'
                    }
                ]
            }).addTo(this.mapa);
        },

        popupControl() {
            const config = {
                position: 'bottomright'
            };
            return ControleLeafletComComponenteVue(
                Popup,
                this.mapa,
                {},
                config
            );
        },

        getLayerByName(layerName) {
            return this.markers[layerName] || null;
        },

        addPointLayer(layerConfig) {
            const layer = L.geoJSON(layerConfig.geoJson, {
                pointToLayer: function (feature, latlng) {
                    let marker = layerConfig.icon
                        ? L.marker(latlng, { icon: layerConfig.icon })
                        : new L.CircleMarker(latlng, layerConfig.style);

                    if (layerConfig.tipoCultura) {
                        marker = layerConfig.icon
                            ? L.marker(latlng, { icon: layerConfig.icon })
                            : LayerStyles.MARKER(
                                layerConfig.tipoCultura,
                                latlng
                            );
                    }

                    if (layerConfig.popup) {
                        marker.bindPopup(layerConfig.popup);
                    }

                    if (layerConfig.tooltip) {
                        marker.bindTooltip(layerConfig.tooltip, {
                            direction: 'top'
                        });
                    }

                    if (layerConfig.acaoClick) {
                        marker.on('click', () => layerConfig.acaoClick());
                    }

                    return marker;
                }
            });

            return layer;
        },

        refreshMap() {
            this.mapa.invalidateSize();
            this.centralize();
        },

        fixaZoom(btn) {
            this.desabilitaZoom = !this.desabilitaZoom;
            if (this.desabilitaZoom) {
                this.mapa.scrollWheelZoom.disable();
                this.mapa.doubleClickZoom.disable();
                this.mapa.boxZoom.disable();
                this.mapa.touchZoom.disable();
                this.mapa.dragging.disable();
            } else {
                this.mapa.scrollWheelZoom.enable();
                this.mapa.doubleClickZoom.enable();
                this.mapa.boxZoom.enable();
                this.mapa.touchZoom.enable();
                this.mapa.dragging.enable();
                this.limparMenuFerramentasAtivo = true;
            }
        },

        computeBoundsFromMapLayersConfigs() {
            let bounds = L.latLngBounds();

            this.mapLayersConfigs.forEach(layerConfig => {
                const geoJson = layerConfig.geoJson;

                if (!geoJson) {
                    return;
                }

                if (geoJson.type === 'Point') {
                    const coords = geoJson.coordinates;
                    bounds.extend([coords[1], coords[0]]);
                } else if (geoJson.type === 'Polygon' || geoJson.type === 'MultiPolygon' || geoJson.type === 'LineString' || geoJson.type === 'MultiLineString') {
                    const layer = L.geoJSON(geoJson);
                    bounds.extend(layer.getBounds());
                }
            });

            return bounds;
        },

        centralize() {
            if (this.desabilitaZoom) return;

            if (this.camadaCentralizadaNome === null) {
                if (this.mapa) {
                    if (
                        this.permissaoAmbiente(this.ambientes.PARAGUAY) &&
                        this.idMapa !== 'mapaSobreposicaoTerritorio'
                    ) {
                        this.mapa.setView(
                            DEFAULT_CONFIG_PARAGUAY.center,
                            DEFAULT_CONFIG_PARAGUAY.zoom
                        );
                    } else {
                        this.mapa.setView(DEFAULT_CONFIG.center, DEFAULT_CONFIG.zoom);
                    }
                }
            } else {
                let layer = this.camadas[this.camadaCentralizadaNome];

                if (layer) {
                    if (layer.getBounds) {
                        this.mapa.fitBounds(layer.getBounds());
                    } else if (layer.getLatLng) {
                        this.mapa.setView(layer.getLatLng(), 17);
                    }
                } else {
                    this.centralizeToBounds();
                }
            }
            this.leafletClassesFixamapa = false;
        },

        centralizeToBounds() {
            const bounds = this.computeBoundsFromMapLayersConfigs();

            if (bounds.isValid()) {
                this.mapa.fitBounds(bounds, {
                    maxZoom: 17
                });
            } else {
                this.mapa.setView(DEFAULT_CONFIG.center, DEFAULT_CONFIG.zoom);
            }
        },

        clearLayers() {
            if (this.featureGroup) {
                this.featureGroup.clearLayers();
            }
            if (this.clusterLayer) {
                this.clusterLayer.clearLayers();
            }

            this.camadas = {};
        },

        limparLayerSelecionadaZoom() {
            if (this.layerSelecionadaZoom) {
                this.mapa.removeLayer(this.layerSelecionadaZoom);
                this.layerSelecionadaZoom = null;
            }
        },

        limparAreaAgricultavelLayerSelecionadaZoom() {
            for (let geometria of this.geometrias) {
                this.mapa.removeLayer(geometria);
            }
            this.geometrias = [];
        },

        changeMapInteractive() {
            let lockFunc = 'enable';
            if (this.locked) {
                lockFunc = 'disable';
            }

            this.mapa.dragging[lockFunc]();
            this.mapa.touchZoom[lockFunc]();
            this.mapa.doubleClickZoom[lockFunc]();
            this.mapa.scrollWheelZoom[lockFunc]();
            this.mapa.boxZoom[lockFunc]();
            this.mapa.keyboard[lockFunc]();

            if (this.mapa.tap) this.mapa.tap[lockFunc]();
        },

        changeMapInteractiveDrawers(lockInteractive) {
            let lockFunc = 'enable';
            if (lockInteractive) {
                lockFunc = 'disable';
            }

            this.mapa.dragging[lockFunc]();
            this.mapa.touchZoom[lockFunc]();
            this.mapa.doubleClickZoom[lockFunc]();
            this.mapa.scrollWheelZoom[lockFunc]();
            this.mapa.boxZoom[lockFunc]();
            this.mapa.keyboard[lockFunc]();

            if (this.mapa.tap) this.mapa.tap[lockFunc]();
        },

        ativarDesativarCamadasPorNome(layers) {
            layers.forEach(layer => {
                if (layer) {
                    const existeArea = this.mapLayersConfigs.find(
                        m => m.name === layer.name
                    );
                    if (existeArea) {
                        this.mapLayersConfigs = this.mapLayersConfigs.filter(
                            m => m.name !== layer.name
                        );
                    } else {
                        this.mapLayersConfigs.push(layer);
                    }
                }
            });
        },

        fullscreenControl() {
            this.mapa.addControl(
                new L.Control.Fullscreen({
                    position: 'topright'
                })
            );
        },

        draw() {
            this.emitEventsTerritorio();
            if (this.mapa.doubleClickZoom.enabled()) {
                if (!this.drawPolygon.enabled()) {
                    this.drawPolygon.enable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').addClass('active');
                } else {
                    this.drawPolygon.disable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                }
            }
        },

        drawCalc() {
            this.closePopup();
            this.emitEventsTerritorio();
            if (!this.drawPolygonCalc.enabled()) {
                this.drawPolygonCalc.enable();
                $(this.selectorIdMapa + ' .leaflet-interactive.drawCalc').addClass('active');
            } else {
                this.drawPolygonCalc.disable();
                $(this.selectorIdMapa + ' .leaflet-interactive.drawCalc').removeClass('active');
            }
        },

        removerDesenho(identificadorGeometria) {
            let layerToRemove = null;

            layerToRemove = Object.values(this.mapa._layers).find(
                l => l.identificadorGeometria === identificadorGeometria
            );

            if (layerToRemove) {
                layerToRemove.removeFrom(this.mapa);
                return;
            }

            layerToRemove = this.featureGroup
                .getLayers()
                .find(l => l.identificadorGeometria === identificadorGeometria);

            if (layerToRemove) {
                layerToRemove.off();
                this.featureGroup.removeLayer(layerToRemove);
                return;
            }

            Object.values(this.mapa._layers).forEach(l => {
                if (
                    l.feature &&
                    l.feature.geometry &&
                    l.feature.geometry.identificadorGeometria ===
                    identificadorGeometria
                ) {
                    layerToRemove = l;
                }
            });

            if (layerToRemove) {
                layerToRemove.removeFrom(this.mapa);
            }
        },

        markerControl() {
            $(
                this.selectorIdMapa + ` .leaflet-interactive.marker-active[title="${this.$t('mensagens.menuMapa.iconesFerramentas.cliqueParaMarcar')}"]`
            ).addClass('marcador');

            let mapa = this.mapa;

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            this.drawMarker = new L.Draw.Marker(this.mapa, {
                icon: pinIcon,
                draggable: true
            });

            const self = this;

            this.mapa.on(L.Draw.Event.CREATED, e => {
                if (self.dadosDaAnotacao === null) {
                    let layer = e.layer;
                    layer.layerType = e.layerType;

                    this.showPopupAcoes(layer);
                }
            });

            this.mapa.on('popupopen', function (e) {
                let px = mapa.project(e.target._popup._latlng);
                px.y -= e.target._popup._container.clientHeight / 2;
                mapa.panTo(mapa.unproject(px), { animate: true });
            });
        },

        elegibilidadeFormatada(elegivel) {
            if (elegivel === null) {
                return this.$t('mensagens.laudos.nao-classificado');
            } else if (elegivel) {
                return this.$t('mensagens.laudos.elegivel');
            } else {
                return this.$t('mensagens.laudos.inelegivel');
            }
        },

        showPopupAcoes(layer) {
            let mapa = this.mapa;
            let layerPlanilha = layer.layerPlanilha !== undefined && layer.layerPlanilha === true;
            if (layer.options.draggable !== true) {
                layer.options.draggable = true;
                this.featureGroup.addLayer(layer);
                this.$emit('draw-created', layer);
            }

            let acoes = [];

            const elegibilidadeInfo = document.createElement('p');
            elegibilidadeInfo.classList.add('elegibilidade-info');
            if (layer.layerInfo && layer.layerInfo.codigo !== '') {
                elegibilidadeInfo.innerHTML = `${this.$t('mensagens.menuMapa.elegibilidadeRenovabio')}<br><span class=${layer.layerInfo.elegivel_renovabio ? 'elegivel' : layer.layerInfo.elegivel_renovabio == null ? 'nao-classificado' : 'inelegivel'}>${this.elegibilidadeFormatada(layer.layerInfo.elegivel_renovabio)}`;

                if (layer.layerInfo.elegivel_renovabio != null) {
                    acoes.push({
                        id: 1,
                        botao: `<i class="el el-icon-search text-white"><span>${this.$t('mensagens.laudos.gerarLaudoRenovabio')}</span></i>`,
                        acao: () => {
                            this.geometriaAcao = layerPlanilha ? layer.geometry : layer.toGeoJSON().geometry;
                            this.$notify.info({
                                message: this.$t('mensagens.sistema.redirecionadoParaTelaSolicitacaoLaudo')
                            });
                            setTimeout(() => {
                                this.$router.push({
                                    path: 'laudo/renovabio',
                                    query: {acao: 'SOLICITAR_LAUDO_RENOVABIO', car: layer.layerInfo.codigo}
                                });
                            }, 3000);
                        }
                    });
                }
            }

            if (this.mapConfig.inspecionar) {
                acoes.push({
                    id: 3,
                    botao: `<i class="el el-icon-search text-white"><span> ${this.$t('mensagens.menuMapa.inspecionar')}</span></i>`,
                    acao: () => {
                        this.geometriaAcao = layerPlanilha ? layer.geometry : layer.toGeoJSON().geometry;
                        this.mostrarModalSelecionarCamadas = true;
                        setTimeout(() => {
                            this.handleModalInspecionarCamadasFullscreen();
                        }, 100);
                    }
                });
            }

            if (this.mapConfig.diagnostico) {
                acoes.push({
                    id: 4,
                    botao: `<i class="flow flow-environment text-white"><span> ${this.$t('mensagens.menuMapa.diagnostico')}</span></i>`,
                    acao: () => {
                        this.geometriaAcao = layerPlanilha ? layer.geometry : layer.toGeoJSON().geometry;
                        this.setGeometriaDesenhadaAcao(this.geometriaAcao);
                        this.setAcaoEscolhida('DIAGNOSTICO');

                        this.$router.currentRoute.name ===
                            'DiagnosticoSocioambiental'
                            ? this.$emit('diagnostico', this.geometriaAcao)
                            : (this.mostrarModalEnviarGeometriaDiagnostico = true);
                    }
                });
            }

            acoes.push({
                id: 6,
                botao: `<i class="el el-icon-delete text-white"><span> ${this.$t('mensagens.menuMapa.remover')}</span></i>`,
                acao: () => {
                    this.$emit(
                        'removerTerritorio',
                        layer.identificadorGeometria
                    );
                    mapa.removeLayer(layer);
                }
            });

            const botaoHistoricoAgricola = {
                id: 2,
                botao: `<i class="flow flow-environment text-white"><span> ${this.$t('mensagens.menuMapa.historicoAgricola')}</span></i>`,
                acao: () => {
                    this.geometriaAcao = layerPlanilha ? layer.geometry : layer.toGeoJSON().geometry;
                    this.mostrarDrawerHistoricoAgricola = true;
                    this.closePopup();
                }
            };

            const botaoDownloadKml = {
                id: 5,
                botao: `<i class="el el-icon-download text-white"><span> ${this.$t('mensagens.menuMapa.baixarPoligono')}</span></i>`,
                acao: () => {
                    this.geometriaAcao = layerPlanilha ? layer.geometry : layer.toGeoJSON().geometry;
                    UtilsService.baixarKMLdeGeometria(
                        this.geometriaAcao
                    );
                    this.closePopup();
                }
            };

            if (
                this.usuarioLogado.historicoMonitoramentoAccess &&
                (this.mapConfig.historicoMonitoramento === undefined ||
                    this.mapConfig.historicoMonitoramento === true)
            ) {
                acoes.push(botaoHistoricoAgricola);
            }

            if (layer.layerType === 'polygon') {
                acoes.push(botaoDownloadKml);
            }

            acoes = sortBy(acoes, ['id']);

            const elMenu = document.createElement('div');
            elMenu.setAttribute('id', 'menu-popup-ponto');

            let areaHa;
            if (layerPlanilha) {
                areaHa = this.formatAreaHa(
                    geometryUtils.calcularAreaHaFromLayerPlanilha(layer)
                );
            } else {
                areaHa = this.formatAreaHa(
                    geometryUtils.calcularAreaHaFromLayer(layer)
                );
            }
            const areaInfo = document.createElement('p');
            if (layerPlanilha) {
                areaInfo.innerHTML = `${this.$t('mensagens.menuMapa.areaPoligono')}<br>${areaHa} (ha)`;
            } else if (layer.toGeoJSON().geometry.type !== 'Point') {
                areaInfo.innerHTML = `${this.$t('mensagens.menuMapa.areaPoligono')}<br>${areaHa} (ha)`;
            }

            elMenu.appendChild(elegibilidadeInfo);

            acoes.forEach(({ id, botao, acao }) => {
                const elBtnAcao = document.createElement('a');
                elBtnAcao.classList.add('btn');
                elBtnAcao.classList.add('container-botoes-inspecionar');
                if (id !== 6) {
                    elBtnAcao.classList.add('btn');
                } else {
                    elBtnAcao.classList.add('btn-danger');
                }

                elBtnAcao.innerHTML = botao;
                elBtnAcao.href = 'javascript:void(0)';
                elBtnAcao.onclick = acao;

                elMenu.appendChild(elBtnAcao);
            });

            if (layer.layerType === 'marker') {
                const elLatLng = document.createElement('p');
                elLatLng.setAttribute('class', 'latlng-popup');
                elLatLng.innerHTML = `${this.$t('mensagens.menuMapa.latitude')}: ${layer._latlng.lat.toFixed(
                    4
                )} <br> ${this.$t('mensagens.menuMapa.longitude')}: ${layer._latlng.lng.toFixed(4)}`;

                elMenu.appendChild(elLatLng);
                this.limparMenuFerramentasAtivo = true;
            }

            elMenu.appendChild(areaInfo);

            layer.bindPopup(elMenu, {
                maxWidth: 'auto'
            });

            switch (layer.layerType) {
                case 'marker':
                    $(
                        this.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    break;

                case 'polygon':
                    $(this.selectorIdMapa + ' .leaflet-interactive.drawCalc').removeClass('active');
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                    break;
            }
        },

        showMarker(e) {
            let coordenadas = [this.config.center[0], this.config.center[1]];
            if (e.latlng !== undefined) {
                coordenadas[0] = e.latlng.lat;
                coordenadas[1] = e.latlng.lng;
            }

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            let marker = L.marker(coordenadas, {
                icon: pinIcon,
                draggable: true
            });
            this.mapa.addLayer(marker);

            let mapa = this.mapa;

            const elDiv = document.createElement('div');
            elDiv.className = 'divPopup';

            let elA = document.createElement('a');
            elA.className = 'btn btn-danger text-white removerMarcador';
            elA.innerHTML = `<i class="mdi mdi-delete-outline">${this.$t('mensagens.menuMapa.remover')}</i>`;
            elA.href = 'javascript:void(0)';
            elA.onclick = function () {
                mapa.removeLayer(marker);
            };

            const elLatLng = document.createElement('p');
            elLatLng.setAttribute('class', 'latlng-popup');
            elLatLng.innerHTML = `${this.$t('mensagens.menuMapa.latitude')}: ${parseFloat(e.latlng.lat).toFixed(
                4
            )}  ${this.$t('mensagens.menuMapa.longitude')}: ${parseFloat(e.latlng.lng).toFixed(4)}`;

            elDiv.appendChild(elA);

            elDiv.appendChild(elLatLng);

            marker.bindPopup(elDiv, {
                maxWidth: 'auto'
            });

            let px = mapa.project(marker.getLatLng());
            px.y -= marker.getPopup().getContent().clientHeight / 2;
            mapa.panTo(mapa.unproject(px), { animate: true });
        },

        dadosFormCoodernadas(dados) {
            let latitude = dados.latitude.completo;
            let longitude = dados.longitude.completo;

            if (dados.tipo === 'gms') {
                const input = {
                    lat: dados.latitude.completo,
                    lon: dados.longitude.completo
                };
                const decimalCoords = toDecimal(input);
                latitude = decimalCoords.lat;
                longitude = decimalCoords.lon;
            } else if (dados.tipo === 'utm') {
                const utmCoord =
                    dados.utm.fuso +
                    ' ' +
                    dados.utm.hemisferio +
                    ' ' +
                    dados.utm.x +
                    ' ' +
                    dados.utm.y;
                const utm = Utm.parse(utmCoord);
                const coords = utm.toLatLon();
                latitude = coords.lat;
                longitude = coords.lng;
            }

            try {
                this.showMarker({
                    latlng: {
                        lat: latitude,
                        lng: longitude
                    }
                });

                this.closePopup();
            } catch (e) {
                this.$notify.info({
                    message: this.$t('mensagens.menuMapa.erro.naoFoiPossivelObterArea')
                });
            }
        },

        createMarkerOnClick() {
            this.closePopup();
            this.emitEventsTerritorio();
            if (!this.drawMarker.enabled()) {
                this.drawMarker.enable();
                $(this.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador').addClass(
                    'active'
                );
                $(this.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador').attr(
                    'title',
                    `${this.$t('mensagens.menuMapa.iconesFerramentas.cliqueParaDesmarcar')}`
                );
            } else {
                this.drawMarker.disable();
                $(this.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador').removeClass(
                    'active'
                );
                $(this.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador').attr(
                    'title',
                    `${this.$t('mensagens.menuMapa.iconesFerramentas.cliqueParaMarcar')}`
                );
            }
        },

        closePopup() {
            this.mapa.eachLayer(function (layer) {
                layer.closePopup();
            });
        },

        formatarCamposMarker(
            campo,
            digitos = 7,
            numerosNegativos = true,
            min = null,
            max = null
        ) {
            var element = document.getElementsByName(campo)[0];
            var maskOptions = {
                mask: Number,
                scale: digitos,
                signed: numerosNegativos,
                normalizeZeros: true,
                padFractionalZeros: true,
                radix: '.'
            };

            if (min) {
                maskOptions.min = min;
            }

            if (max) {
                maskOptions.max = max;
            }

            IMask(element, maskOptions);
        },

        selecionarCamadas({ latlng }) {
            this.geometriaAcao = {
                type: 'Point',
                coordinates: [latlng.lng, latlng.lat]
            };

            this.mostrarModalSelecionarCamadas = true;
            setTimeout(() => {
                this.handleModalInspecionarCamadasFullscreen();
            }, 100);
        },

        inspecionar(camadasSelecionasModal) {
            this.camadasInspecao = camadasSelecionasModal;
            this.mostrarModalSelecionarCamadas = false;

            this.mostrarDrawerInspecionar = true;

            const pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            if (this.geometriaAcao.coordinates.length === 2) {
                this.pinIcon = L.marker(
                    [
                        this.geometriaAcao.coordinates[1],
                        this.geometriaAcao.coordinates[0]
                    ],
                    { icon: pinIcon }
                );
                this.mapa.addLayer(this.pinIcon);
            }

            const vm = this;

            let fullscreenAtivado = document.querySelector(
                this.selectorIdMapa + ' [title="Exit Fullscreen"]'
            );

            if (fullscreenAtivado) {
                $(vm.selectorIdMapa).prepend(
                    $('#drawer-inspecionar-camadas')
                );
            }
        },

        fecharDrawerInspecionar() {
            this.mostrarDrawerInspecionar = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        drawerHistoricoAgricolaFechar() {
            this.mostrarDrawerHistoricoAgricola = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        openCamadaControl() {
            $('.componente-camadas__botao-controle').on('click', this.handleControlToggle);
            this.mapa.on('click', this.closeCamadaControl);
        },

        closeCamadaControl() {
            if ($('.componente-camadas__container.expandido').length > 0) {
                $('.componente-camadas__botao-controle').trigger('click');
                $('.componente-camadas__container').removeClass('expandido');

                this.handleControlToggle();
            }
        },

        emitEventsTerritorio() {
            EventBus.$emit('mapa:desativar-se-ativo-selecao');
        },

        visualizarAreaMonitoradaSocioambiental(id) {
            this.$router.push({
                name: 'VisualizarMonitoramentoSocioambiental',
                params: { idAreaMonitorada: id }
            });
        },

        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        addBotaoAnotacoes() {
            L.easyButton({
                id: 'botao-anotacao',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-anotacao',
                        onClick: this.modalAnotacao,
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.adicionarAnotacao'),
                        icon: 'mdi mdi-comment-text-outline'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoFerramentas() {
            L.easyButton({
                id: 'botao-ferramentas',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-ferramentas',
                        onClick: this.toggleMenuFerramentas,
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.ferramentas'),
                        icon: 'mdi mdi-wrench-outline mdi-flip-h'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoArea() {
            L.easyButton({
                id: 'botao-area',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-area',
                        onClick: this.toggleMenuArea,
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.area'),
                        icon: 'mdi mdi-vector-square mdi-flip-h'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoSentinelHub(cadastroTerritorio) {
            if (!cadastroTerritorio) {
                L.easyButton({
                    id: 'botao-sentinel-hub',
                    position: 'topright',
                    states: [
                        {
                            stateName: 'bloco-sentinel-hub',
                            onClick: this.toggleFerramentasSentinelHub,
                            title: this.$t('mensagens.menuMapa.iconesFerramentas.imagensSentinel2'),
                            icon: 'mdi mdi-satellite-variant'
                        }
                    ]
                }).addTo(this.mapa);
            }
        },

        adicionarAnotacao(formDadosAnotacao) {
            this.dadosDaAnotacao = formDadosAnotacao;
            this.emitEventsTerritorio();

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/mdi_comment-text-outline-white.png',
                iconSize: [36, 36]
            });

            this.drawMarkerAnotacao = new L.Draw.Marker(this.mapa, {
                icon: pinIcon,
                draggable: true
            });

            const self = this;

            this.mapa.on(L.Draw.Event.CREATED, event => {
                if (self.dadosDaAnotacao !== null) {
                    const marker = event.layer;

                    const containerPopupAnotacoes =
                        this.criarElementoPopupAnotacoes(self, marker);

                    const customOptions = {
                        'maxWidth': 'auto',
                        'className': 'customPopup'
                    };

                    var newpopup = L.popup({
                        closeOnClick: false,
                        autoClose: false
                    }).setContent(containerPopupAnotacoes);

                    marker.addTo(self.mapa).bindPopup(newpopup, customOptions).openPopup();

                    const closePopupButton = document.querySelector('a.leaflet-popup-close-button');
                    let customPopupLast = document.querySelectorAll('.customPopup');
                    let customPopupLastIndex = null;

                    customPopupLast.forEach((item, index) => {
                        customPopupLastIndex = index;
                    });

                    if (document.querySelectorAll('.customPopup')[customPopupLastIndex]) {
                        document.querySelectorAll('.customPopup')[customPopupLastIndex].childNodes[0].setAttribute('style', 'padding: 0 !important');
                        document.querySelectorAll('.customPopup')[customPopupLastIndex].childNodes[0].childNodes[0].setAttribute('style', 'margin: 0 0 6px 0 !important');
                        closePopupButton.setAttribute('style', 'margin: 2px 3px 0 0');
                    }

                    self.dadosDaAnotacao = null;
                }
            });

            if (!this.drawMarkerAnotacao.enabled()) {
                this.drawMarkerAnotacao.enable();
            }
        },

        criarElementoPopupAnotacoes(self, marker) {
            const idPopupAnotacao = uuid.v1();
            self.dadosDaAnotacao.idPopupAnotacao = idPopupAnotacao;

            // Elemento pai
            const containerPopupAnotacoes = document.createElement('div');
            containerPopupAnotacoes.classList.add('pop-up-anotacao');

            // Elemento do texto
            const headerPopupAnotacoes = document.createElement('div');
            headerPopupAnotacoes.classList.add('pop-up-anotacao-header');
            containerPopupAnotacoes.appendChild(headerPopupAnotacoes);

            const headerTitlePopupAnotacoes = document.createElement('h1');
            headerTitlePopupAnotacoes.classList.add('pop-up-anotacao-header-titulo');
            headerTitlePopupAnotacoes.innerText = `${this.$t('mensagens.menuMapa.anotacao')}`;
            headerPopupAnotacoes.appendChild(headerTitlePopupAnotacoes);

            const textoPopupAnotacoes = document.createElement('p');
            textoPopupAnotacoes.setAttribute('id', 'p-' + idPopupAnotacao);
            textoPopupAnotacoes.setAttribute(
                'style',
                `
                        font-size: 12px;
                        color: ${self.dadosDaAnotacao.style.color};
                        font-weight: ${self.dadosDaAnotacao.style.fontWeight};
                        margin: 8px 10px 20px 14px;
                    `
            );
            textoPopupAnotacoes.innerText = self.dadosDaAnotacao.comentario;
            containerPopupAnotacoes.appendChild(textoPopupAnotacoes);

            const breakLinePopupAnotacoes = document.createElement('hr');
            breakLinePopupAnotacoes.classList.add('pop-up-anotacao-breakline');
            containerPopupAnotacoes.appendChild(breakLinePopupAnotacoes);

            // Elemento do botão remover
            const btnPopupAnotacoesRemover = document.createElement('button');
            btnPopupAnotacoesRemover.setAttribute(
                'class',
                'el-button el-button el-button--danger el-button-custom--danger el-button--mini'
            );
            btnPopupAnotacoesRemover.setAttribute('type', 'button');
            btnPopupAnotacoesRemover.setAttribute('style', 'margin: 6px 28px 5px 8px');
            btnPopupAnotacoesRemover.innerHTML =
                `   <i class="el-icon-delete"></i> ${this.$t('mensagens.menuMapa.remover')}`;
            btnPopupAnotacoesRemover.href = 'javascript:void(0)';
            btnPopupAnotacoesRemover.onclick = self.removerComentario;
            btnPopupAnotacoesRemover.marker = marker;
            containerPopupAnotacoes.appendChild(btnPopupAnotacoesRemover);

            // Elemento do botão editar
            const btnPopupAnotacoesEditar = document.createElement('button');
            btnPopupAnotacoesEditar.setAttribute('id', idPopupAnotacao);
            btnPopupAnotacoesEditar.setAttribute(
                'class',
                'el-button el-button--primary el-button--mini'
            );
            btnPopupAnotacoesEditar.setAttribute('type', 'button');
            btnPopupAnotacoesEditar.innerHTML =
                `<i class="el-icon-edit"></i> ${this.$t('mensagens.menuMapa.editar')}`;
            btnPopupAnotacoesEditar.href = 'javascript:void(0)';
            btnPopupAnotacoesEditar.onclick = self.editarComentario;
            btnPopupAnotacoesEditar.dadosDaAnotacao = self.dadosDaAnotacao;
            containerPopupAnotacoes.appendChild(btnPopupAnotacoesEditar);

            return containerPopupAnotacoes;
        },

        editarComentario(e) {
            this.comentarioEmEdicao = true;
            this.dadosDaAnotacaoEdicao = null;
            if (e.target.dadosDaAnotacao) {
                this.toggleMenuFerramentas();
                if (this.ativarMenuFerramentas === true) {
                    this.dadosDaAnotacaoEdicao = JSON.parse(
                        JSON.stringify(e.target.dadosDaAnotacao)
                    );
                    this.comentarioEmEdicao = true;
                } else {
                    this.dadosDaAnotacaoEdicao = null;
                    this.comentarioEmEdicao = false;
                }
            }
        },

        removerComentario(e) {
            if (e.target.marker) {
                this.mapa.removeLayer(e.target.marker);
            }
        },

        aplicarZoomGeoJson(geoJson) {
            this.limparLayerSelecionadaZoom();
            this.limparAreaAgricultavelLayerSelecionadaZoom();
            if (geoJson) {
                if (this.layerSelecionadaZoom) {
                    this.mapa.removeLayer(this.layerSelecionadaZoom);
                }
                this.layerSelecionadaZoom = L.geoJson(geoJson, {
                    style: getEstiloGeometria('restricaoSelecionadaZoom')
                }).addTo(this.mapa);
                this.mapa.fitBounds(this.layerSelecionadaZoom.getBounds());
            } else {
                this.refreshMap();
            }
        },

        aplicarZoomGeoAreaAgricultavel(areaAgricultavel) {
            this.limparLayerSelecionadaZoom();
            this.limparAreaAgricultavelLayerSelecionadaZoom();
            let grupoBounds = [];
            for (let geom of areaAgricultavel) {
                let geojson = L.geoJson(geom.geometriaAreaAgricultavel, {
                    style: mapaEstilos.Geometria.area
                }).addTo(this.mapa);
                this.geometrias.push(geojson);
                grupoBounds.push(geojson.getBounds());
            }
            this.mapa.fitBounds(grupoBounds);
        },

        toggleMenuFerramentas() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            if (this.ativarMenuFerramentas === false) {
                this.dadosDaAnotacaoEdicao = null;
                const popupBody = document.querySelector(this.selectorIdMapa + ' .leaflet-popup.leaflet-zoom-animated');
                if (popupBody && document.querySelector('.pop-up-anotacao')) {
                    const closePopupButton = popupBody.querySelector('a.leaflet-popup-close-button[href="#close"]');
                    if (closePopupButton && this.comentarioEmEdicao === false) {
                        closePopupButton.click();
                    }
                }
            }

            this.ativarMenuFerramentas = !this.ativarMenuFerramentas;
            this.botaoMenuAtivo(this.selectorIdMapa + ' #botao-ferramentas', this.ativarMenuFerramentas);
            if (this.ativarMenuFerramentas) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-ferramentas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-ferramentas')
                            );
                        }
                    }, 200);
                    this.handleModalAnotacaoInputsOnFullscreen();
                }

                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuArea() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }

            this.ativarMenuArea = !this.ativarMenuArea;
            this.botaoMenuAtivo(this.selectorIdMapa + ' #botao-area', this.ativarMenuArea);
            if (this.ativarMenuArea) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-area'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-area')
                            );
                        }
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuCamadas() {
            const vm = this;
            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarMenuCamadas = !this.ativarMenuCamadas;
            this.botaoMenuAtivoCamadas(this.selectorIdMapa + ' #botao-camadas');
            if (this.ativarMenuCamadas) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-camadas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleFerramentasSentinelHub() {
            if (this.ativarMenuFerramentas) {
                this.toggleMenuFerramentas();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarFerramentasSentinelHub = !this.ativarFerramentasSentinelHub;
            this.botaoMenuAtivo(this.selectorIdMapa + ' #botao-sentinel-hub', this.ativarFerramentasSentinelHub);
            if (this.ativarFerramentasSentinelHub) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    const vm = this;
                    setTimeout(() => {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#ferramentas-sentinel'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#ferramentas-sentinel')
                            );
                        }
                    }, 200);
                    vm.handleSentinelInputsOnFullscreen();
                }

                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector(this.selectorIdMapa + ' .leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        botaoMenuAtivo(seletor, condition) {
            if (condition) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        handleSentinelInputsOnFullscreen() {
            let selectorIdMapa = this.selectorIdMapa;

            setTimeout(() => {
                let datePicker = document.querySelector(
                    selectorIdMapa + ' .el-date-editor'
                );
                datePicker.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        selectorIdMapa + ' [title="Exit Fullscreen"]'
                    );
                    let ferramentasSentinelContainer = document.querySelector(selectorIdMapa + ' #ferramentas-sentinel .el-drawer.rtl');
                    ferramentasSentinelContainer.addEventListener('click', function () {
                        setTimeout(() => {
                            $(selectorIdMapa + ' .leaflet-top').removeClass(
                                'fullscreen-ativado'
                            );
                        }, 10);
                    });
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(
                                selectorIdMapa +
                                ' .ferramentas-sentinel'
                            ).prepend(
                                $('.el-picker-panel.el-date-range-picker')
                            );
                            $(selectorIdMapa + ' .leaflet-top').addClass(
                                'fullscreen-ativado'
                            );
                        }, 20);
                    }
                });
            }, 300);
        },

        handleModalAnotacaoInputsOnFullscreen() {
            let selectorIdMapa = this.selectorIdMapa;

            setTimeout(() => {
                let colorPicker = document.querySelector(
                    selectorIdMapa + ' .el-color-picker__trigger'
                );
                colorPicker.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        selectorIdMapa + ' [title="Exit Fullscreen"]'
                    );
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(
                                selectorIdMapa +
                                ' .modal-anotacao'
                            ).prepend(
                                $('.el-color-dropdown.el-color-picker__panel')
                            );
                        }, 100);
                    }
                });
                let fontTypeSelect = document.querySelector(
                    selectorIdMapa + ' .el-select>.el-input'
                );
                fontTypeSelect.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        selectorIdMapa + ' [title="Exit Fullscreen"]'
                    );
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(
                                selectorIdMapa +
                                ' .modal-anotacao'
                            ).prepend($('.el-select-dropdown.el-popper'));
                        }, 100);
                    }
                });
            }, 300);
        },

        botaoMenuAtivoCamadas(seletor) {
            if (this.ativarMenuCamadas) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        handleModalInspecionarCamadasFullscreen() {
            let fullscreenAtivado = document.querySelector(
                this.selectorIdMapa + ' [title="Exit Fullscreen"]'
            );

            if (fullscreenAtivado) {
                setTimeout(() => {
                    $(this.selectorIdMapa).prepend(
                        $('.el-dialog__wrapper.modal-selecionar-camadas')
                    );
                    $(this.selectorIdMapa).prepend($('.v-modal'));
                }, 200);
            }

        },

        atualizarListaCamadasModalInspecionar(camadas) {
            this.camadasInspecao = camadas.map(camada => camada.codigo);
        }
    },

    beforeDestroy() {
        if (this.mapa) {
            this.mapa.off();
            this.mapa.remove();
            this.mapa = null;
        }

        document.removeEventListener('keyup', this.handleKeyUp);
        window.onclick = null;

        this.featureGroup = null;
        this.drawMarker = null;
        this.drawPolygon = null;
        this.drawPolygonCalc = null;
        this.drawMarkerAnotacao = null;
        this.layerSelecionadaZoom = null;
        this.geometrias = [];
    }
};
</script>

<style lang="scss">
.leaflet-draw-tooltip {
    min-width: 280px;
    margin-left: 500px;
    padding: 5px;
    font-weight: bold;
    background-color: var(--white);
    color: #565656;

    &:before {
        border-right-color: var(--white);
    }
}

.leaflet-draw-tooltip-subtext {
    color: var(--var(--black)) !important;
    font-weight: bold !important;
}

.popup-deslocado {
    .leaflet-popup {
        margin-left: 1025px;
        margin-bottom: -605px;
        transform: none !important;
    }
}

.leaflet-popup-tip-container {
    display: none;
    position: relative;
}

.leaflet-draw-tooltip {
    margin-left: 20px !important;
    min-width: 165px !important;
}

.leaflet-interactive:focus {
    outline: none !important;
}

.leaflet-top.leaflet-right .mdi:before,
.leaflet-top.leaflet-right .mdi-set {
    font-size: large !important;
}

.leaflet-measure-path-measurement div[title='Total area'] {
    background: var(--white);
    padding: 0.5rem;
    border-radius: 0.5rem;
    min-width: 120px;
}

.leaflet-measure-path-measurement {
    margin-top: -50%;
    margin-left: -20px;
}

.leaflet-measure-path-measurement div[title='Total area']:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white);
    bottom: -10px;
    right: 90px;
}

.typeahed {
    width: 60vw !important;
}

.el-collapse-item__header {
    height: 35px !important;
    border: 0 !important;
    line-height: initial !important;
    padding: 25px 0px;
}

.el-collapse {
    border: 0 !important;
}

.showLayerRight {
    display: block;
    height: 100%;
    z-index: 2000;
}

.showLayerMain {
    height: 100%;
    min-height: 100vh;
    box-sizing: border-box;
}

.hideLayerRight {
    right: 0px;
}

.hideLayer {
    top: 0px;
    height: 30px;
    margin-top: 10px;
}

.hideLayerMain {
    height: 250px;
}

.leaflet-center {
    left: 50%;
    transform: translate(-50%, 0%);
}

.leaflet-middle {
    top: 50%;
    position: absolute;
    z-index: 1000;
    pointer-events: none;
    transform: translate(0%, -50%);
}

.removerMarcador {
    width: 110px;
}

.leaflet-center.leaflet-middle {
    transform: translate(-50%, -50%);
}

.buffer-container {
    background: transparent;
}

.leaflet-control-buffer {
    width: 100%;
    background: transparent;
    border: none !important;
    text-align: center;
}

.expandido {
    height: 100%;
}

.leaflet-top.leaflet-right {
    overflow-y: auto;
    pointer-events: all;
    padding-left: 8px;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    border-bottom-left-radius: 5px;
    transition: all 0.25s linear;
}

.leaflet-menu-aberto {
    right: 0px;
    transform: translateX(-360px);
}

.leaflet-menu-fechado {
    right: 0px;
    transform: translateX(0px);
}

.leaflet-menu-menor-aberto {
    right: 0px;
    transform: translateX(-247px);
}

.leaflet-menu-menor-fechado {
    right: 0px;
    transform: translateX(0px);
}

#menu-popup-ponto {
    .btn {
        background-color: var(--primary);
        width: 100%;
        min-width: 105px;
        margin-bottom: 4px;
        text-align: left !important;
        height: 24px;

        span {
            font-family: 'Roboto', sans-serif !important;
        }
    }

    .btn:last-of-type {
        background-color: var(--danger);
    }

    .btn:hover {
        background-color: var(--secondary);
    }

    .btn:last-of-type:hover {
        background-color: var(--color-alert);
    }

    .btn::before {
        margin-right: 4px;
    }

    .container-botoes-inspecionar {
        display: flex;
        align-items: center;
        font-size: 12px;
    }
}

.btn-realizar-diagnostico,
.btn-visualizar {
    background-color: var(--primary);
    border-radius: 5px;
    text-align: center;
    color: var(--white);
    padding: 6px;
    font-size: 12px;
    margin-top: 4px;
    cursor: pointer;

    i {
        font-size: 16px;
    }
}

.pop-up-anotacao {
    min-height: 58px;
    min-width: 230px;
    word-break: break-all;
}

.pop-up-anotacao-header {
    height: 33px;
    background-color: var(--light);
    width: 100%;

    .pop-up-anotacao-header-titulo {
        font-size: 14px;
        color: var(--primary);
        margin: 0 0 0 5px;
        padding: 8px;
        font-weight: bold;
    }
}

.pop-up-anotacao-breakline {
    margin-bottom: 1px;
    color: var(--gray);
    border: 1 solid;
}

.anotacao-ativo {
    background-color: var(--$secondary) !important;
}

.el-button-custom--danger {
    background-color: #f56c6c !important;
    color: #fff !important;
}

.el-button-custom--danger:hover {
    background-color: #ec3232 !important;
    color: #fff !important;
}

.leaflet-bar {
    border-radius: 10px;
}

.active {
    background-color: var(--secondary) !important;

    span {
        color: var(--white) !important;
    }
}

.none {
    display: none !important;
}

.fullscreen-ativado {
    z-index: 498 !important;
}

.cluster-marker {
  border-radius: 50%;
  color: #fff;
  text-align: center;
  border: 1px solid #fff;
}

.cluster-marker div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cluster-marker span {
  font-size: 12px;
}

.cluster-marker-small {
  width: 30px;
  height: 30px;
  background-color: rgba(56, 128, 255, 0.6);
}

.cluster-marker-medium {
  width: 35px;
  height: 35px;
  background-color: rgba(231, 197, 1, 0.671);
}

.cluster-marker-large {
  width: 40px;
  height: 40px;
  background-color: rgba(216, 104, 0, 0.6);
}

.cluster-marker-xlarge {
  width: 45px;
  height: 45px;
  background-color: rgba(216, 32, 0, 0.6);
}

.elegibilidade-info {
    font-weight: bold;
}
.elegivel{
    color: var(--success);
}
.inelegivel{
    color: var(--danger);
}
.nao-classificado{
    color: var(--gray);
}
</style>
